import { dashboardManifest } from '@/features/dashboard/manifest'
import { taxonomiesManifest } from '@/features/catalogs/taxonomies/manifest'
import { productsManifest } from '@/features/catalogs/products/manifest'
import { catalogPublishManifest } from '@/features/catalogs/publish/manifest'
import { cartsManifest } from '@/features/orders/carts/manifest'
import { ordersManifest } from '@/features/orders/orders/manifest'
import { orderProcessingManifests } from '@/features/orders/processing/manifest'
import { shippingInfoManifest } from '@/features/orders/shipping-info/manifest'
import { humanEmployeesManifest, humanPayrollsManifest } from '@/features/human/manifest'
import { myPayrollManifest } from '@/features/employee-self/payroll/manifest'
import { myEmployeeProfileManifest } from '@/features/employee-self/profile/manifest'
import { inventoryItemsManifest, inventorySuppliersManifest, inventoryPurchasesManifest, productStockManifest } from '@/features/inventory/manifest'
import { marketingContentManifest, marketingReportManifest, marketingPersonasManifest } from '@/features/marketing/manifest'

export const featureManifests = [
  dashboardManifest,
  taxonomiesManifest,
  productsManifest,
  catalogPublishManifest,
  cartsManifest,
  ordersManifest,
  ...orderProcessingManifests,
  shippingInfoManifest,
  humanEmployeesManifest,
  humanPayrollsManifest,
  myEmployeeProfileManifest,
  myPayrollManifest,
  inventoryItemsManifest,
  inventorySuppliersManifest,
  inventoryPurchasesManifest,
  productStockManifest,
  marketingContentManifest,
  marketingReportManifest,
  marketingPersonasManifest,
]
